<mat-form-field appearance="outline" class="ced-busca-produto" subscriptSizing="dynamic">
  <mat-label>Buscar produto</mat-label>
  <mat-icon matIconPrefix class="material-symbols-outlined">search</mat-icon>
  <input #buscaProdutoInput
         matInput
         type="text"
         placeholder="Nome ou SKU do produto…"
         [ngModel]="query"
         (ngModelChange)="onQueryChange($event)"
         [matAutocomplete]="autoProduct">
  @if (buscando) {
    <mat-progress-spinner matSuffix mode="indeterminate" diameter="18"></mat-progress-spinner>
  }
  <mat-autocomplete #autoProduct="matAutocomplete" (optionSelected)="selecionar($event.option.value)">
    @for (r of resultados; track r.sku || r.name) {
      <mat-option [value]="r">
        <div class="ced-opt-produto">
          <span class="ced-opt-produto__nome">{{ r.name }}</span>
          <span class="ced-opt-produto__meta">
            @if (r.sku) { SKU {{ r.sku }} · } @if (r.marca) { {{ r.marca }} · } estoque {{ r.stock }} {{ r.unit }}
          </span>
        </div>
      </mat-option>
    }
    @if (!buscando && resultados.length === 0 && query.trim().length > 1) {
      <mat-option disabled>Nenhum produto encontrado.</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
